import { InvalidCredentialsError } from "../../../domain/errors/invalid-credentials-error";
import { UnexpectedError } from "../../../domain/errors/unexpected-error";
import { User, UserProps, UserRequestProps, UserResponseModel } from "../../../domain/models/user";
import { HttpClient, HttpStatusCode } from "../../protocols/http/http-client";

export class RemoteUser implements User {
  constructor(
    private readonly url: string,
    private readonly httpPostClient: HttpClient,
  ) { }

  async create(body: UserRequestProps): Promise<UserProps> {
    const httpResponse = await this.httpPostClient.request({
      url: this.url,
      body,
      method: "post",
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.created:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }

  async update(id: number, body: Omit<UserRequestProps, "password">): Promise<UserProps> {
    const httpResponse = await this.httpPostClient.request({
      url: `${this.url}/${id}`,
      body,
      method: "put",
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }

  async load(): Promise<UserProps> {
    const httpResponse = await this.httpPostClient.request({
      url: this.url,
      method: "get",
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }

  async list(params?: any): Promise<UserResponseModel> {
    const httpResponse = await this.httpPostClient.request({
      url: `${this.url}/filter`,
      method: "get",
      params,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }

  async findById(id: number): Promise<UserProps> {
    const httpResponse = await this.httpPostClient.request({
      url: `${this.url}/${id}`,
      method: "get",
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }

  async delete(id: number): Promise<void> {
    const httpResponse = await this.httpPostClient.request({
      url: `${this.url}/${id}`,
      method: "delete",
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
